import RemoveConnectionsModal from './RemoveConnectionsModal';

export default RemoveConnectionsModal;